'use client';

import { Card } from '@packages/shared/src/ui/Card/Card';
import { Image } from '@packages/shared/src/ui/Image/Image';
import { getSampleImageUrl } from '../../utils/getSampleImageUrl/getSampleImageUrl';
import type { SampleEntry } from '../../SampleOrderSteps/types';

export type SampleItemProps = SampleEntry & {
  actionHandler(): void;
  selected: boolean;
  groupName: string;
};

export const SampleItem = ({
  image,
  name,
  actionHandler,
  selected,
  groupName,
}: SampleItemProps) => (
  <Card
    tabIndex={0}
    onClick={actionHandler}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); // To prevent scrolling, when card is clicked.
        actionHandler();
      }
    }}
    className="bg-color-text-light relative h-full w-[7.875rem] cursor-pointer overflow-hidden"
  >
    {/* ImageBox - here the sample image will be rendered */}
    <div className="relative h-[7.875rem] w-full [&>img]:object-fill">
      <Image
        unoptimized
        src={getSampleImageUrl(image)}
        alt={`${groupName} - ${name}`}
        width={126}
        height={126}
      />
    </div>
    {/* TextBox - here the sample name will be rendered */}
    <div className="p-[0.75rem] text-center leading-[0.875rem] break-words hyphens-auto">
      <p className="text-size-body3">{name}</p>
    </div>
    {/* Overlay - this the colored overlay that appears when a sample is selected */}
    <div
      className={`absolute top-0 right-0 bottom-0 left-0 z-[2] rounded-[inherit] border-solid ${selected ? 'border-color-primary border-[0.125rem]' : 'border-color-grey-dark border-[0.0625rem]'}`}
    >
      <div
        className={`${selected ? 'bg-color-primary' : 'bg-color-transparent'} h-full w-full opacity-20`}
      />
    </div>
    {/* Checkmark - when a sample is selected it gets a checkmark - this has to be over the overlay */}
    {selected && (
      <span className="icon-emp-checkmark-inverted-20 text-color-primary absolute top-1 right-1 z-10 h-[1.25rem] w-[1.25rem]" />
    )}
  </Card>
);
